import { Fragment } from 'react';

export type WorkspaceImageInfoRow = {
  id: string;
  label: string;
  value: string;
  description?: string;
};

/** Tools opt in by supplying their own resolved copy and display values. */
export function WorkspaceImageInfoCard({
  rows,
}: { rows: readonly WorkspaceImageInfoRow[] }) {
  if (rows.length === 0) return null;
  return (
    <dl className="cms-workspace-image-info__details">
      {rows.map((row) => (
        <Fragment key={row.id}>
          <dt>{row.label}</dt>
          <dd>
            {row.value}
            {row.description && <small>{row.description}</small>}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
}
